import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AIPoweredEcommerceSolutionsInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="AI-Powered E-commerce Solutions in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Transform Your Store</Subheading>}
        heading={
          <Heading>
            AI-Powered <span tw="text-primary-500">E-commerce Solutions</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver AI-powered e-commerce solutions in
            **Dubai International Financial Centre (DIFC)** to revolutionize
            your online store. Harness AI for personalized experiences, smarter
            operations, and exponential growth.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI technology visualization
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Modern tech workspace
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce with digital elements
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Go AI-Powered"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Smart E-commerce Solutions in DIFC"
        description="We leverage AI to elevate your online store."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "AI Expertise",
            description: "Advanced AI tools tailored to e-commerce.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Personalized Shopping",
            description: "Custom recommendations boost sales.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Predictive Analytics",
            description: "Anticipate trends and customer needs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Automated Operations",
            description: "Streamline inventory and support.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Seamless Integration",
            description: "AI works across all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Innovators choose us for AI solutions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our AI Implementation Process"
        description={
          <Description>
            We integrate AI into e-commerce with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your business goals.</li>
              <li>Strategy: Design AI-driven features.</li>
              <li>Development: Build and integrate AI tools.</li>
              <li>Testing: Ensure accuracy and performance.</li>
              <li>Launch: Deploy a smart, AI-powered store.</li>
              <li>Support: Optimize and update AI systems.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI data visualization
          "https://images.unsplash.com/photo-1594979194853-f7dcd77a0a1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team working on AI solutions
          "https://images.unsplash.com/photo-1550439062-609e1531270e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Digital analytics dashboard
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Explore AI Solutions"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Impact</Subheading>}
        heading="AI-Powered Success in DIFC"
        description="Our AI solutions transform e-commerce."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "AI recommendations doubled revenue.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Customer Engagement",
            description: "Personalized experiences grew loyalty.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "High praise for AI innovation.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Smart E-commerce?</Subheading>}
        heading="AI-Powered Solutions in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for AI-powered e-commerce solutions in
            DIFC. Build a smarter, future-ready online store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577043710482-1b3c7a7e5128?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline with tech overlay
          "https://images.unsplash.com/photo-1556740764-0434cfcb1e41?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce payment technology
          "https://images.unsplash.com/photo-1536148935331-408321065b18?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI connection visualization
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
